export default __webpack_public_path__ + "static/media/32-icon-mute.5e5711d4.svg";